<template>
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">{{ item.id ? 'Edit' : 'New' }} other section<br>
                <div class="mt-1">
                  <div class="form-check form-check-success form-switch d-flex align-items-center">
                    <input
                      id="publishContent"
                      v-model="item.active"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      for="publishContent"
                    ><small class="ms-1">{{ labels['active'] }}</small></label>
                  </div>
                </div>
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to areas & groups list"
              @click="$router.push({name: 'researcher.administration.other-sections.index'})"
            ><i data-feather="chevron-left" /></a>
            <a
              v-if="loggedUser.roles.includes('super-admin')"
              class="btn btn-icon btn-flat-secondary"
              @click="$store.dispatch('modals/toggleRequestModal', 'OtherSection')"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>

      <div class="content-body content-body--senior-call">
        <div
          v-if="errors != ''"
          class="alert alert-danger mt-1 p-1"
        >
          {{ errors }}
        </div>
        <div class="row">
          <div class="col-12">
            <SearchResearcher :item="item" />

            <div class="card">
              <div class="card-header">
                <h3 class="cart-title">
                  <a data-action="collapse">Content</a>
                </h3>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li>
                      <a data-action="collapse"><i data-feather="chevron-down" /></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-content collapse show">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-8">
                      <div class="mb-1 form-group required">
                        <label
                          for=""
                          class="form-label"
                        >{{ labels['content.name'] }}</label>
                        <input
                          v-model="item.name"
                          class="form-control"
                          type="text"
                        >
                      </div>
                    </div>
                    <!-- <div class="col-sm-2">
                      <div class="mb-1 form-group required">
                        <label
                          for=""
                          class="form-label"
                        >Code</label>
                        <input
                          v-model="item.code"
                          class="form-control"
                          type="text"
                        >
                      </div>
                    </div> -->
                    <div class="col-sm-4">
                      <div class="mb-1 form-group required">
                        <label
                          for=""
                          class="form-label"
                        >{{ labels['content.order'] }}</label>
                        <input
                          v-model="item.order"
                          class="form-control"
                          type="number"
                        >
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <div class="mb-1 form-group required">
                        <label
                          for=""
                          class="form-label"
                        >{{ labels['content.description'] }}</label>
                        <quill-editor v-model="item.description" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <AddFile
              :id="6"
              :title="'Files'"
              :type="3"
              :files="item.files_"
            />

            <AttachedForm
              :type="'OtherSection'"
              :model-id="otherSectionId"
            />
          </div>
        </div>

        <div class="page-actions">
          <button
            v-if="!sending"
            id="type-success"
            class="btn btn-success"
            @click="save"
          >
            <i data-feather="save" />
            <span class="ms-25 align-middle">Save and Exit</span>
          </button>
          <button
            v-else
            class="btn btn-outline-success"
            type="button"
            disabled=""
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span class="ms-25 align-middle">Saving...</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import AddFile from '../../../admin/senior-call/components/AddFile.vue'
import SearchResearcher from '../../../partials/components/SearchResearcher.vue'
import 'vue2-datepicker/index.css'
import AttachedForm from '../../../forms/partials/AttachedForm.vue'

export default {
  components: {
    AddFile,
    SearchResearcher,
    AttachedForm,
  },
  data() {
    return {
      otherSectionId: this.$route.params.id,
      dateAlert: 0,
      sending: false,
      errors: '',
    }
  },
  computed: {
    ...mapGetters({
      item: 'otherSections/item',
      statuses: 'status/statuses',
      hosts: 'institutions/institutions',
      labels: 'sectionLabels/itemLabels',
      attached: 'requestForms/attached',
      loggedUser: 'auth/admin',
    }),
  },
  async mounted() {
    this.$store.dispatch('sectionLabels/fetchLabels', 'other_sections.other_sections')
    if (this.otherSectionId) {
      await this.$store.dispatch('otherSections/fetchId', this.otherSectionId)
    } else {
      await this.$store.dispatch('otherSections/cleanType')
    }

    this.$store.dispatch('status/filterStatus', 'Unpaid leaves')
  },
  methods: {
    saveFiles(files) {
      this.item.files_ = files.data
    },
    async save() {
      this.sending = true
      this.item.attached_form = this.attached
      try {
        if (this.otherSectionId) {
          await this.$store.dispatch('otherSections/update', { id: this.otherSectionId, data: this.item })
        } else {
          await this.$store.dispatch('otherSections/create', this.item)
        }
        this.errors = ''
      } catch (e) {
        this.errors = e.response.data.message
      }

      if (this.errors === '' && this.item.id) {
        Vue.swal('Other section has been saved correctly!', '', 'success').then(() => {
          this.$router.push({ name: 'researcher.administration.other-sections.index' })
        })
      } else {
        // Vue.swal
      }

      this.sending = false
    },
    saveNewNote(note) {
      this.item.notes.push(note)
    },
    async onSearch(search, store) {
      search.active = true
      if (search.name !== '') {
        await this.$store.dispatch(store, search)
      }
    },
  },
}
</script>
